import { render, staticRenderFns } from "./ScoreRulesBuilder.vue?vue&type=template&id=7c6f437e&scoped=true&"
import script from "./ScoreRulesBuilder.vue?vue&type=script&lang=ts&"
export * from "./ScoreRulesBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f437e",
  null
  
)

export default component.exports